"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolList = void 0;
const ArticleList_1 = require("../ArticleList");
const Espool_1 = require("./Espool");
const ArticleUtils_1 = require("../ArticleUtils");
class EspoolList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new EspoolList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new EspoolList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new EspoolList();
        list.fromJson(model);
        return list;
    }
    static fromArray(arr) {
        const list = new EspoolList();
        list.fromArray(arr);
        return list;
    }
    clone() {
        return EspoolList.fromArray(this.items.map((i) => i.clone()));
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(Espool_1.Espool.fromJson(itemJson, cloneStrategy));
        }
    }
    fromModel(model) {
        this.items = model.map((i) => Espool_1.Espool.fromModel(i));
        this.model = model;
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * generates from list a map which contains the serieKuerzel as key and as values all possible ArtNrs as array
     */
    getSerieArtNrMap() {
        const serieArtNrMap = new Map();
        this.items.forEach((espool) => {
            const serieKuerzel = espool.getLocalizedSerieKuerzel();
            if (serieKuerzel && espool.artNr) {
                const alreadyInMap = serieArtNrMap.get(serieKuerzel);
                if (Array.isArray(alreadyInMap)) {
                    serieArtNrMap.set(serieKuerzel, [...alreadyInMap, espool.artNr]);
                }
                else {
                    serieArtNrMap.set(serieKuerzel, [espool.artNr]);
                }
            }
        });
        return serieArtNrMap;
    }
}
exports.EspoolList = EspoolList;
//# sourceMappingURL=EspoolList.js.map